export default __webpack_public_path__ + "static/media/MainScreen_GameBG.93e88910.jpg";